import { Button, Container, Modal, Text } from "basis";
import { FormActions } from "components/FormActions/FormActions";

interface Props {
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isOpen: boolean;
}

export const Cancel = ({ isOpen, onClose, loading, onConfirm }: Props) => (
  <Modal title="Cancel this application?" open={isOpen} onClose={onClose}>
    <Text>
      If you want to apply for a credit limit increase in the future you will
      have to re-enter the required information.
    </Text>
    <Modal.Footer>
      <Container width="100%" width-xs="360">
        <FormActions switchLayoutAt="xs">
          <FormActions.Primary>
            <Button
              width="100%"
              variant="primary"
              onClick={onConfirm}
              loading={loading}
            >
              Yes
            </Button>
          </FormActions.Primary>
          <FormActions.Secondary>
            <Button width="100%" variant="secondary" onClick={onClose}>
              No
            </Button>
          </FormActions.Secondary>
        </FormActions>
      </Container>
    </Modal.Footer>
  </Modal>
);
